module.exports = __webpack_public_path__ + "img/arrowLeft.664443c7.svg";